var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"m-achievement-singles"},_vm._l((_vm.achievements),function(achievement,key){return _c('AchievementSingle',{key:key,attrs:{"achievement":achievement,"target":_vm.target,"jump":_vm.jump,"initFold":true}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }